import { reduxKey } from './constants';
export function getChatHasMessage(state) {
    if (!state[reduxKey]) {
        return false;
    }
    return state[reduxKey];
}
